import React, { useEffect, useState } from 'react'
import Spiner from '../../components/modals/Spiner'
import userLogic from '../../functions/logic/userLogic'
import { useSearchParams } from 'react-router-dom'
import '../../scss/order-rastreo.scss'

export default function OrderRastreo() {
  const [load, setLoad] = useState(false)
  const [searchParams] = useSearchParams()
  const order = searchParams.get('orden')
  const [trackingStates, setTrackingStates] = useState([])
  const [noOrderFound, setNoOrderFound] = useState(false)

  useEffect(() => {
    setLoad(true)
    getRastreo(order)
    setLoad(false)
  }, [order])

  const getRastreo = async (order) => {
    const token = localStorage.getItem('authToken')
    let dataResp = []
    const isLoggedIn = !!token

    if (isLoggedIn) {
      dataResp = await userLogic.getRastreoLogic(order)

      if (
        !dataResp.data ||
        (Array.isArray(dataResp.data) && dataResp.data.length === 0)
      ) {
        setNoOrderFound(true)
        setTrackingStates([])
      } else {
        setTrackingStates(
          Array.isArray(dataResp.data) ? dataResp.data : [dataResp.data]
        )
        setNoOrderFound(false)
      }
    } else {
      setNoOrderFound(true)
      setTrackingStates([])
    }
  }

  return (
    <main className="easybuy-order-tracking">
      <Spiner opt={load} />

      <div className="container">
        <div className="easybuy-order-tracking-header text-center">
          <span className="easybuy-order-tracking-badge">
            <i className="la la-truck"></i>
            Seguimiento de pedido
          </span>

          <h2>Rastreo de Orden #{order}</h2>

          <p>Consulta el estado y progreso de tu pedido.</p>
        </div>

        {noOrderFound ? (
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="easybuy-order-error">
                <div className="easybuy-order-error-icon">
                  <i className="la la-search"></i>
                </div>

                <h3>No encontramos tu pedido</h3>

                <p>
                  No existe información para el número de orden ingresado.
                  Verifique el número e intente nuevamente o inicie sesión para
                  poder consultar sus rastreos.
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="easybuy-order-timeline">
                {trackingStates.map((state, index) => (
                  <div key={index} className="easybuy-order-step">
                    <div className="easybuy-order-step-marker">
                      <span
                        className={state.completado ? 'completed' : 'pending'}
                      >
                        <i
                          className={
                            state.completado ? 'la la-check' : 'la la-clock-o'
                          }
                        ></i>
                      </span>
                    </div>

                    <div className="easybuy-order-card">
                      <div className="easybuy-order-card-header">
                        <div>
                          <span className="easybuy-order-step-label">
                            {state.completado ? 'Completado' : 'Pendiente'}
                          </span>

                          <h3>{state.nombre2 || 'Estado desconocido'}</h3>
                        </div>

                        <i className="la la-angle-right"></i>
                      </div>

                      <div className="easybuy-order-description">
                        <p>{state.descripcion || 'Sin descripción'}</p>
                      </div>

                      <div className="easybuy-order-details">
                        <div className="easybuy-order-detail">
                          <span>
                            <i className="la la-calendar"></i>
                            Fecha de inicio
                          </span>

                          <strong>{state.fecha || 'En espera...'}</strong>
                        </div>

                        <div className="easybuy-order-detail">
                          <span>
                            <i className="la la-calendar-check-o"></i>
                            Fecha de finalización
                          </span>

                          <strong>
                            {state.fecha_finalizacion || 'En espera'}
                          </strong>
                        </div>

                        <div className="easybuy-order-detail easybuy-order-notes">
                          <span>
                            <i className="la la-file-text"></i>
                            Notas
                          </span>

                          <strong>{state.notas || 'Sin notas'}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </main>
  )
}
